import BillingsOrderForwardTaxiTaxiAddResponse from "../../../../../api/raily/billings/order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add.response";
import BillingsOrderForwardTaxiTaxiAdd from "./billings-order-forward-taxi-taxi-add";

const create = (
  response: BillingsOrderForwardTaxiTaxiAddResponse,
): BillingsOrderForwardTaxiTaxiAdd => {
  return {
    id: response.data.id,
  };
};

const billingsOrderForwardTaxiTaxiAddFactory = {
  create,
};

export default billingsOrderForwardTaxiTaxiAddFactory;
